// BASE_URL for APIS https://backend.eatcoast.ca/v1/api
// const BASE_URL = "http://localhost:5055/api";
const BASE_URL = "https://ec-backend.vercel.app/api";
//  ----------- yeh meri deployment hai
// const BASE_URL = "https://ec-backend-deployed.vercel.app/api";
// const BASE_URL = "https://ec-backend-deployed-hib09djd0-m-saim786.vercel.app/api"; // new deployement
const IMAGE_URL = "http://res.cloudinary.com/druo8nrp9/image/upload/"
// const BASE_URL = "https://ec-backend-nine.vercel.app/api";
const token = localStorage.getItem("token");
const config = {
  "Authorization": `Bearer ${token}`,
};

export { config, BASE_URL, IMAGE_URL };
